import { format, isWithinInterval } from 'date-fns';
import { EmptyListEventItem } from '../../../../../core/components/molecules/EmptyListEventItem';
import {
  EventItem,
  EventTag,
} from '../../../../../core/components/molecules/EventItem';
import { LiveClass } from '../../../models/LiveClassDto.model';

interface iAprovaLiveListProps {
  items: LiveClass[];
  onClick: (item: LiveClass) => void;
}

function AprovaLiveList({ items, onClick }: iAprovaLiveListProps) {
  return (
    <ul className='flex flex-col'>
      {items.length > 0 ? (
        items.map((item) => {
          const startDate = new Date(item.startDate);
          const endDate = new Date(item.endDate);

          const startTime = format(startDate, 'HH:mm');

          const itsHappeningNow = isWithinInterval(new Date(), {
            start: startDate,
            end: endDate,
          });

          const isOnboarding = item.type === 'onboarding';

          const tags = [
            {
              label: isOnboarding ? 'Onboarding' : 'AprovaLive',
              variant: 'neutral',
            },
            {
              label: item.area?.title,
              variant: item.area?.slug,
            },
          ].filter((tag) => tag.label) as EventTag[];

          return (
            <EventItem
              key={item._id}
              teacherName={item.teacher}
              title={item.title}
              startTime={startTime}
              itsHappeningNow={itsHappeningNow}
              tags={tags}
              showCheckIcon={item.isSubscribed}
              onClick={() => onClick(item)}
            />
          );
        })
      ) : (
        <EmptyListEventItem type='AprovaLive'/>
      )}
    </ul>
  );
}

export { AprovaLiveList };
